import React from 'react';

const PageContent = ({post}) => (
  <div className="page-content">
    <h1>{post.title}</h1>
    <p>{post.text}</p>
  </div>
);

export default PageContent;